export type NavbarPrimaryLink = {
  label: string;
  href: string;
};

export type NavbarDropdownLink = {
  label: string;
  href: string;
};

export type NavbarDropdownSection = {
  title: string;
  links: NavbarDropdownLink[];
};

export type NavbarContent = {
  brandHref: string;
  primaryLinks: NavbarPrimaryLink[];
  servicesDropdown: NavbarDropdownSection[];
  cta: {
    label: string;
    href: string;
  };
};

const CKL_BASE_URL_EN = "https://cheesecakelabs.com/en";

export const navbarContentEn: NavbarContent = {
  brandHref: `${CKL_BASE_URL_EN}/`,
  primaryLinks: [
    { label: "Services", href: `${CKL_BASE_URL_EN}/services/` },
    { label: "Portfolio", href: `${CKL_BASE_URL_EN}/portfolio/` },
    { label: "About", href: `${CKL_BASE_URL_EN}/about/` },
    { label: "Careers", href: `${CKL_BASE_URL_EN}/careers/` },
    { label: "Blog", href: `${CKL_BASE_URL_EN}/blog/` },
  ],
  servicesDropdown: [
    {
      title: "Custom Softwares",
      links: [
        {
          label: "Mobile App Development",
          href: `${CKL_BASE_URL_EN}/services/#mobile-app-development`,
        },
        {
          label: "Web App Development",
          href: `${CKL_BASE_URL_EN}/services/#web-app-development`,
        },
        {
          label: "DevOps and Cloud Services",
          href: `${CKL_BASE_URL_EN}/services/#web-app-development`,
        },
        {
          label: "Backend Development",
          href: `${CKL_BASE_URL_EN}/services/#web-app-development`,
        },
        {
          label: "IoT Development",
          href: `${CKL_BASE_URL_EN}/services/#mobile-app-development`,
        },
      ],
    },
    {
      title: "Emerging Technologies",
      links: [
        {
          label: "AI Software Development",
          href: `${CKL_BASE_URL_EN}/services/ai-development/`,
        },
        {
          label: "Data Modernization & Engineering",
          href: `${CKL_BASE_URL_EN}/services/ai-development/`,
        },
        {
          label: "Blockchain Development",
          href: `${CKL_BASE_URL_EN}/services/blockchain/`,
        },
      ],
    },
    {
      title: "Strategic Design",
      links: [
        {
          label: "Product Strategy",
          href: `${CKL_BASE_URL_EN}/services/#product-strategy`,
        },
        { label: "UX/UI Design", href: `${CKL_BASE_URL_EN}/services/#ux-ui-design` },
      ],
    },
    {
      title: "IT Outsourcing",
      links: [
        {
          label: "Software Outsourcing",
          href: `${CKL_BASE_URL_EN}/services/software-outsourcing/`,
        },
        {
          label: "Staff Augmentation",
          href: `${CKL_BASE_URL_EN}/services/staff-augmentation/`,
        },
        {
          label: "Dedicated Development Team",
          href: `${CKL_BASE_URL_EN}/services/dedicated-team/`,
        },
      ],
    },
  ],
  cta: {
    label: "Schedule a call",
    href: `${CKL_BASE_URL_EN}/contact/`,
  },
};
